import { CirclePlus } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const AddCircleIcon = createLucideIcon(CirclePlus);
